var api = require("!../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../css-loader/dist/cjs.js!../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?{\"source\":\"Ll8xNzBpOHJ1MCB7CiAgb3ZlcmZsb3c6IGhpZGRlbjsKICBwb3NpdGlvbjogcmVsYXRpdmU7CiAgcGFkZGluZzogMCAwIDUwcHg7Cn0KLl8xNzBpOHJ1MSB7CiAgd2lkdGg6IDEwMCU7CiAgbWF4LXdpZHRoOiAxMDB2dzsKfQouXzE3MGk4cnUyIHsKICB3aWR0aDogMTAwJTsKICBtYXgtd2lkdGg6IG1pbig1NTFweCwgMTAwdncpOwogIG1hcmdpbjogMCBhdXRvOwp9\"}!./vanilla-extract-webpack-plugin-extracted.cjs.js");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};